import React from 'react';
import { Users, Megaphone } from 'lucide-react';
import { fmtTime } from './chatShared';
import { ChatAvatar } from './ChatAvatar';
import { EmojiText } from './EmojiText';

export const ChatConvItem = ({ c, me, active, onSelect, prefix = 'chat' }) => {
  const other = c.type === 'direct' ? (c.members.find((m) => m.id !== me?.id) || {}) : null;
  return (
    <button type="button" onClick={() => onSelect(c.id)} data-testid={`${prefix}-conv-${c.id}`}
      className={`w-full text-left px-3 py-3 flex gap-2 items-start transition-colors ${active ? 'bg-sky-50' : 'hover:bg-slate-50'}`}>
      {other
        ? <ChatAvatar name={other.name} url={other.avatar_url} testId={`${prefix}-conv-avatar-${c.id}`} />
        : <span className="w-9 h-9 rounded-full bg-[#2D3E6F]/10 text-[#2D3E6F] flex items-center justify-center shrink-0">{c.type === 'broadcast' ? <Megaphone className="w-4 h-4 text-amber-600" /> : <Users className="w-4 h-4" />}</span>}
      <span className="flex-1 min-w-0">
        <span className="flex items-center justify-between gap-1">
          <span className={`text-sm truncate ${c.unread && c.is_member ? 'font-bold text-slate-900' : 'font-medium text-slate-700'}`}>{c.name}</span>
          {c.urgent_open > 0 && <span className="text-[9px] uppercase font-bold text-white bg-rose-600 rounded px-1 shrink-0 animate-pulse" data-testid={`${prefix}-conv-urgent-${c.id}`}>Urgente {c.urgent_open}</span>}
          {!c.is_member && <span className="text-[9px] uppercase font-bold text-amber-700 bg-amber-100 rounded px-1 shrink-0" data-testid={`${prefix}-conv-readonly-${c.id}`}>Só leitura</span>}
          <span className="text-[10px] text-slate-400 shrink-0">{fmtTime(c.last_message_at)}</span>
        </span>
        <span className="flex items-center justify-between gap-1">
          <span className="text-xs text-slate-500 truncate">{c.last_message_preview ? <EmojiText text={c.last_message_preview} size="1.2em" /> : 'Sem mensagens'}</span>
          {c.unread > 0 && c.is_member && <span className="text-[10px] font-bold bg-rose-500 text-white rounded-full px-1.5 min-w-[18px] text-center" data-testid={`${prefix}-unread-${c.id}`}>{c.unread}</span>}
        </span>
      </span>
    </button>
  );
};
